<template>
    <vx-card>
        <div id="release-loading" class="vs-con-loading__container">
            <vs-row
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="12"
            >
                <vs-col vs-w="5" vs-justify="flex-start" vs-align="flex-start">
                    <h4 style="color: #b4aa99; display: flex; flex-direction: column;">
                        <span>Releases</span>
                        <small style="font-size: 11px; margin-top: 5px;">Frontend build: {{ frontendVersion }} | Backend build: {{ backendVersion }}</small>
                    </h4>
                </vs-col>
                <vs-col vs-w="7" vs-type="flex" vs-justify="flex-end" vs-align="flex-end">
                    <ModalRelease @update="buscarReleases" />
                    <vs-input
                        color="dark"
                        class="mx-1"
                        size="small"
                        type="text"
                        label="Busca"
                        placeholder="Buscar..."
                        v-model="filtro.busca"
                    ></vs-input>

                    <vs-input
                        color="dark"
                        class="mx-1"
                        size="small"
                        type="date"
                        label="Atualização De"
                        v-model="filtro.dataAtualizacaoDe"
                    ></vs-input>
                    
                    <vs-input
                        color="dark"
                        class="mx-1"
                        size="small"
                        type="date"
                        label="Atualização Até"
                        v-model="filtro.dataAtualizacaoAte"
                    ></vs-input>
                    <el-button
                        size="small"
                        type="primary"
                        class="ml-1"
                        plain
                        @click="pagina=1; buscarReleases(true)"
                    >FILTRAR</el-button>
                </vs-col>
                <div id="table" class="w-full mt-4">
    
                <div class="my-10 py-10" v-if="releases.length == 0">
                    <div class="con-colors my-10 py-10">
                        <ul>
                            <li class="danger-box">
                                <h2 class="p-5" style="color: white !important">
                                    Nenhuma Release registrada
                                </h2>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else>
                    <div class="release-list-container">
                        <div class="release-column">
                            <div 
                                v-for="release in releases"
                                :key="release.id"
                                class="release-card"
                            >
                                <div class="release-top">
                                    <div class="release-version">
                                        Release {{ release.versao }}
                                        <span v-if="release.id === idReleaseMaisRecente" class="recent-tag">Mais Recente</span>
                                    </div>
            
                                    <div class="release-actions" @click.stop>
                                        <ModalRelease 
                                            :release="release" 
                                            @update="buscarReleases" 
                                        />
                                    </div>
                                </div>
                                <div class="release-date">
                                    Atualizado em {{ formatDate(release.dataAtualizacao) }}
                                </div>
                                
                                <div 
                                    class="release-toggle"
                                    @click="toggleRelease(release.id)"
                                >
                                    {{ expanded.includes(release.id) ? 'Ocultar Release Notes' : 'Ver Release Notes' }}
                                    <span class="arrow">
                                        {{ expanded.includes(release.id) ? '▲' : '▼' }}
                                    </span>
                                </div>
            
                                <transition name="fade">
                                    <div 
                                        v-if="expanded.includes(release.id)"
                                        class="release-details"
                                    >
                                        <div class="ql-editor p-0" v-html="release.descricao"></div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                    </div>
                    
                    <div class="flex flex-wrap items-center justify-between mt-4 px-2">
                        <span class="text-sm text-grey-dark">Total: {{ totalRegistros }} registros</span>
                        <vs-pagination 
                            :total="totalPaginas" 
                            v-model="pagina" 
                            @change="buscarReleases(true)"
                        ></vs-pagination>
                    </div>
                </div>
            </div>
            </vs-row>
        </div>
    </vx-card>
</template>
<script>
import ModalRelease from './modalRelease.vue';
import 'quill/dist/quill.core.css';

export default {
    components: {
        ModalRelease
    },
    data () {
        return {
            releases: [],
            expanded: [],
            filtro: {
                busca: '',
                dataAtualizacaoDe: '',
                dataAtualizacaoAte: ''
            },
            pagina: 1,
            itensPorPagina: 20,
            totalRegistros: 0
        }
    },
    computed: {
        frontendVersion() {
            return process.env.VUE_APP_FRONTEND_VERSION;
        },
        backendVersion() {
            return process.env.VUE_APP_BACKEND_VERSION;
        },
        idReleaseMaisRecente() {
            if (!this.releases || this.releases.length === 0) return null;
            const maisRecente = this.releases.reduce((prev, current) => {
                const dataPrev = new Date(prev.dataAtualizacao);
                const dataCurrent = new Date(current.dataAtualizacao);
                if (isNaN(dataPrev.getTime())) return current; 
                if (isNaN(dataCurrent.getTime())) return prev; 
                return (dataPrev > dataCurrent) ? prev : current;
            }, this.releases[0]);
            return maisRecente ? maisRecente.id : null;
        },
        totalPaginas() {
            if (this.totalRegistros === 0) return 0;
            return Math.ceil(this.totalRegistros / this.itensPorPagina);
        }
    },
    methods: {
        async buscarReleases(usarLoading = false){
            if(usarLoading) {
                this.$vs.loading({ container: "#release-loading", scale: 0.6 });
            }
            try{
                const parametros = {
                    pagina: this.pagina,
                    busca: this.filtro.busca,
                    dataAtualizacaoDe: this.filtro.dataAtualizacaoDe,
                    dataAtualizacaoAte: this.filtro.dataAtualizacaoAte
                };

                const dados = await this.$http.get(`release`, { params: parametros });
                
                if (dados.success && dados.data) {
                    this.releases = dados.data.data || [];
                    this.totalRegistros = dados.data.total || 0;
                    if (dados.data.porPagina || dados.data.perPage) {
                        this.itensPorPagina = dados.data.porPagina || dados.data.perPage;
                    }
                } else {
                    this.releases = dados.data || [];
                    this.totalRegistros = dados.total || 0;
                }

                if(usarLoading) {
                    this.$vs.loading.close("#release-loading > .con-vs-loading");
                }
            }catch(erro){
                console.log(erro);
                let message = 'Não foi possível carregar as releases';
                if (erro.response && erro.response.data && erro.response.data.message) {
                    message = erro.response.data.message;
                }
                this.$vs.notify({title: 'Erro',text: message,color: 'danger'});
                if(usarLoading) {
                    this.$vs.loading.close("#release-loading > .con-vs-loading");
                }
            }
        },
        toggleRelease(id) {
            if (this.expanded.includes(id)) {
                this.expanded = this.expanded.filter(r => r !== id)
            } else {
                this.expanded.push(id)
            }
        },

        formatDate(date) {
            if (!date) return ''
            return new Date(date).toLocaleDateString('pt-BR')
        }
    },
    async mounted () {
        this.$vs.loading({ container: "#release-loading", scale: 0.6 });
        try {
            await this.buscarReleases();
        } finally {
             this.$vs.loading.close("#release-loading > .con-vs-loading");
        }
    },
}
</script>
<style>
    .select-example {
        min-width: 200px;
    }
    .release-list-container {
        border-radius: 10px;
        padding: 18px;
        margin-bottom: 15px;
        background: #fff;
        height: 70vh;
        overflow-y: auto;
        display: flex;
        gap: 15px;
        width: 100%;
        overflow-x: hidden;
    }

    .release-column {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 15px;
        min-width: 0; /* Crucial for preventing flex overflow */
    }

    .release-card {
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        padding: 18px;
        margin-bottom: 15px; 
        transition: 0.2s ease;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        break-inside: avoid; 
        display: inline-block; 
        width: 100%;
    }

    .release-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .release-version {
        font-weight: bold;
        font-size: 16px;
    }

    .release-toggle {
        margin-top: 12px;
        font-size: 13px;
        color: #2563eb;
        font-weight: 600;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        gap: 5px;
    }

    .release-toggle:hover {
        text-decoration: underline;
    }

    .release-card:hover {
        box-shadow: 0 4px 12px rgba(0,0,0,0.06);
    }

    .release-card.deleted {
        opacity: 0.5;
    }

    .release-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .release-description {
        margin-top: 8px;
        font-size: 14px;
        color: #555;
    }

    .release-details {
        margin-top: 15px;
        border-top: 1px solid #eee;
        padding-top: 12px;
    }

    .tipo-group {
        margin-bottom: 10px;
    }

    .release-item {
        font-size: 13px;
        margin-left: 10px;
        margin-top: 4px;
    }

    .expand-indicator {
        font-weight: bold;
        font-size: 16px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.2s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .release-system {
        display: inline-block;
        background: #eef2ff;
        color: #1e3a8a;
        padding: 3px 8px;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 600;
        margin-bottom: 4px;
        margin-top: 4px;
    }

    .release-date {
        font-size: 12px;
        color: #8c8c8c;
        margin-top: 2px;
    }

    .release-middle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 4px;
        margin-bottom: 4px;
    }
    .no-items {
        font-size: 13px;
        color: #999;
        font-style: italic;
        margin-top: 8px;
    }

    .recent-tag {
        background-color: #28c76f;
        color: white;
        padding: 2px 8px;
        border-radius: 12px;
        font-size: 10px;
        font-weight: bold;
        text-transform: uppercase;
        margin-left: 8px;
        display: inline-block;
        vertical-align: middle;
    }
</style>